export default __webpack_public_path__ + "9e0841a15f7067ef0be79662da9386be.png";